import React from 'react';
import { Button } from '../ui/button';
import { LogOut, Building2 } from 'lucide-react';
import { NotificationBell } from '../NotificationBell';
import { NotificationPreferences } from '../NotificationPreferences';
import { InstallPushButtons } from '../InstallPushButtons';

export function ResidentHeader({ user, communityName, navigate, handleLogout, setShowAddCommunityModal }) {
  return (
    <header className="bg-gk-navy text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2 sm:gap-3">
          <img src="/icon-192.png" alt="GateKeeper" className="w-10 h-10 rounded-lg" />
          <div>
            <h1 data-testid="dashboard-community-name" className="text-base sm:text-lg font-bold leading-tight">{communityName}</h1>
            <p className="text-xs text-slate-300 mt-0.5">{user?.name}</p>
            <p className="text-[10px] sm:text-xs text-gk-teal font-medium">Villa {user?.villa_number}</p>
          </div>
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
          <Button
            data-testid="dashboard-add-community-button"
            size="sm"
            onClick={() => setShowAddCommunityModal(true)}
            variant="ghost"
            className="text-white hover:bg-gk-navy-hl"
            title="Add Community"
          >
            <Building2 className="w-4 h-4" />
            <span className="hidden sm:inline ml-1">Add Community</span>
          </Button>
          <div
            data-testid="profile-icon"
            onClick={() => navigate('/profile')}
            className="w-9 h-9 rounded-full bg-gk-teal flex items-center justify-center cursor-pointer hover:bg-gk-teal-hover transition-colors"
            title="My Profile"
          >
            <span className="text-sm font-bold text-white">{user?.name?.[0]?.toUpperCase() || 'U'}</span>
          </div>
          <NotificationPreferences />
          <NotificationBell />
          <InstallPushButtons />
          <Button
            data-testid="logout-button"
            onClick={handleLogout}
            variant="ghost"
            className="text-white hover:bg-gk-navy-hl"
          >
            <LogOut className="w-4 h-4 mr-2" />
            <span className="hidden sm:inline">Logout</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
